import { render, staticRenderFns } from "./ProjectIterator.vue?vue&type=template&id=2309c0b2"
import script from "./ProjectIterator.vue?vue&type=script&lang=js"
export * from "./ProjectIterator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports